import styles from './style.module.css';

// What is shared, and with whom, on the landing page: the lilac box the app
// keeps for private clinician material, listing the sharing rules as they
// ship (C38: accepting an invitation shares the whole diary, never the
// journal).
export function SharingBox({ title, points }) {
  return (
    <section className={ styles.box } aria-labelledby='what-is-shared'>
      <h2 id='what-is-shared' className={ styles.title }>
        <span className={ styles.lock } aria-hidden='true'></span>

        { title }
      </h2>

      <ul className={ styles.points }>
        { points.map(function(point) {
          return <li key={ point }>{ point }</li>;
        }) }
      </ul>
    </section>
  );
}
